import gql from 'graphql-tag';
import { ErrorsAttributes } from '../constants';
import { GroupCoreAttributes } from './groups';
import { InternalNoteCoreAttributes } from './internalNotes';
import { SiteCoreAttributes } from './sites';

export const AccountCoreAttributes = `
id
name
pagesCount
dictionaries
dictionariesLimit
ignoredLinkReasons
`;

const AccountExtraAttributes = `
groups {
  ${GroupCoreAttributes}
}
sites {
  ${SiteCoreAttributes}
}
`;

export const AccountQuery = gql`
  query AccountQuery($accountId: String!) {
    account(accountId: $accountId) {
      ${AccountCoreAttributes}
      ${AccountExtraAttributes}
    }
  }
`;

export const AccountWithNotesQuery = gql`
  query AccountWithNotesQuery($accountId: String!) {
    account(accountId: $accountId) {
      ${AccountCoreAttributes}
      internalNotes {
        ${InternalNoteCoreAttributes}
      }
    }
  }
`;

export const AccountsQuery = gql`
  query AccountsQuery {
    accounts {
      nodes {
        ${AccountCoreAttributes}
        ${AccountExtraAttributes}
      }
    }
  }
`;

export const AccountAttributesForRouting = `
  id
  name
  disabled
  featureFlags
  usesSingleSignOut
  customDomain {
    id
    name
    usesSsoId
    singleSignOnRequired
  }
  accountType
  renewalFrequency
  nextRenewalAt
  subscribedToPagesCount
  agency {
    id
    name
    customDomain {
      id
      name
      usesSsoId
      singleSignOnRequired
    }
  }
`;

export const AccountsQueryForRouting = gql`
  query AccountsQueryForRouting($accountId: String) {
    accounts {
      nodes {
        ${AccountAttributesForRouting}
      }
    }
    currentUser(accountId: $accountId) {
      id
      name
      email
      signInCount
      isSuperUser
      avatarUrl
      avatarColor
      currentRole
      currentMembership {
        id
        role
        ssoId
        issuesFilter
        account {
          id
          name
          customDomain {
            id
            name
            usesSsoId
            singleSignOnRequired
          }
        }
      }
      agencyMembership {
        id
        role
        agency {
          id
          name
        }
      }
      groupMemberships {
        id
        role
        group {
          id
          name
          sites {
            id
            name
          }
        }
      }
      siteMemberships {
        id
        role
        site {
          id
          name
        }
      }
    }
    currentShare {
      account {
        id
      }
    }
  }
`;

export const UpdateAccountMutation = gql`
  mutation UpdateAccount($accountId: String!, $dictionaries: [Dictionary!], $ignoredLinkReasons: [String!]) {
    updateAccount(accountId: $accountId, dictionaries: $dictionaries, ignoredLinkReasons: $ignoredLinkReasons) {
      account {
        ${AccountCoreAttributes}
        ${AccountExtraAttributes}
        ${ErrorsAttributes}
      }
    }
  }
`;


export const dictionaries = [
  'blank',
  'en_US',
  'en_GB',
  'en_CA',
  'en_AU',
  'en_MED',
  'da',
  'nl',
  'fr',
  'fr_CA',
  'finnish',
  'de',
  'it',
  'nb',
  'nn',
  'pl',
  'pt',
  'pt_PT',
  'es_US',
  'sv',
  'vi',
  'cy_GB',
]
